<template>
  <transition name="slide-fade" mode="out-in">
    <router-view/>
  </transition>
</template>

<script>
  export default {
    name: 'Order',
  }
</script>


<style scoped>
  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter {
    transform: translateY(15px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-15px);
    opacity: 0;
  }
</style>